import React, { useState, useEffect } from 'react';
import { Activity, RefreshCw, Shield, UserCheck, UserX } from 'lucide-react';
import { supabase } from '../utils/supabaseClient';
import '../styles/admin-audit.css';

const AuditLogs = () => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => { fetchLogs(); }, []);

  const fetchLogs = async () => {
    setLoading(true);
    const { data, error } = await supabase
      .rpc('get_all_profiles');

    if (!error && data) {
      const auditEntries = data.slice(0, 50).map(u => ({
        id: u.id,
        email: u.email,
        name: u.full_name || 'No name',
        action: u.role === 'blocked' ? 'Account Blocked' :
                u.role === 'admin' ? 'Admin Role Granted' : 'Account Active',
        timestamp: u.updated_at || u.created_at,
        type: u.role === 'blocked' ? 'warning' :
              u.role === 'admin' ? 'admin' : 'success',
      }));
      setLogs(auditEntries);
    }
    setLoading(false);
  };

  const getActionIcon = (type) => {
    switch (type) {
      case 'warning': return <UserX size={14} />;
      case 'admin': return <Shield size={14} />;
      default: return <UserCheck size={14} />;
    }
  };

  return (
    <div className="audit-page">
      <div className="admin-dash-header">
        <div>
          <h1 className="admin-dash-title">Audit Logs</h1>
          <p className="admin-dash-subtitle">Recent account activity and admin actions</p>
        </div>
        <button className="admin-refresh-btn" onClick={fetchLogs}>
          <RefreshCw size={15} className={loading ? 'spinning' : ''} />
          Refresh
        </button>
      </div>

      <div className="audit-card">
        {loading ? (
          <div className="user-table-loading">
            <div className="admin-spinner-lg" />
            <p>Loading logs...</p>
          </div>
        ) : logs.length === 0 ? (
          <div className="user-table-empty">
            <Activity size={32} color="#333" />
            <p>No audit logs available yet.</p>
          </div>
        ) : (
          <div className="audit-list">
            {logs.map((log, index) => (
              <div key={`${log.id}-${index}`} className={`audit-row audit-row-${log.type}`}>
                <div className={`audit-icon audit-icon-${log.type}`}>
                  {getActionIcon(log.type)}
                </div>
                <div className="audit-info">
                  <p className="audit-action">{log.action}</p>
                  <p className="audit-user">{log.name} · {log.email}</p>
                </div>
                <div className="audit-time">
                  {new Date(log.timestamp).toLocaleString('en-US', {
                    month: 'short', day: 'numeric',
                    hour: '2-digit', minute: '2-digit'
                  })}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default AuditLogs;
